export default {
    enter_address: 'Molimo unesite adresu',
    edit_address: 'Izmenite adresu',
    enter_address_here: 'Unesite adresu ovde',
    buttons: {
        create_new: 'Dodaj novu lokaciju',
        back: 'Nazad',
    },
    only_supported_country: 'Od država trenutno podržavamo Srbiju i Bosna i Herceovinu! Radimo na tome da proširimo i na druge.',
    company_bosnia_country:
        'Adresa kompanije je u Bosni i Hercegovini, i samo lokacije iz Bosne i Hercegovine mogu da se dodaju.',
    company_serbia_country: 'Adresa kompanije je u Srbiji, i samo lokacije iz Srbije mogu da se dodaju.',
    deleted_success: 'Lokacija uspešno izbrisana!',
    no_locations: 'Nemate dodatih lokacija!',
}
